import { useEffect, useState } from 'react';

export const SMALL_DEVICE_MAX_WIDTH = 768;

interface WindowDimensions {
  width: number;
  height: number;
}
const getWindowDimensions = (): WindowDimensions => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const useWindowDimensions = (): WindowDimensions => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
};

export const useIsSmallViewportWidth = (): boolean => {
  const { width } = useWindowDimensions();
  return width <= SMALL_DEVICE_MAX_WIDTH;
};
